import React from 'react'
import { find, compact, get, map } from 'lodash'
import { withRouter } from 'react-router-dom'
import { func } from 'prop-types'
import Field from './_Field'
import { ContentfulQuery } from '../ContentfulDataProvider'

@withRouter
class PersonToContactInput extends React.PureComponent {
  static contextTypes = {
    refreshDefaultContactID: func,
  }

  render() {
    const contactIDParam = get(this.props.match, 'params.contactID')
    return (
      <Field
        type="select"
        model=".contactID"
        label="Person to Contact"
        required
      >
        <option value="contact.name_cpcdenomination">CPC Denomination</option>
        <optgroup label="Churches">
          <ContentfulQuery
            query={{
              content_type: 'church',
              select: 'fields.title,fields.leadership',
              order: 'fields.title',
            }}
            afterFetch={data =>
              this.context.refreshDefaultContactID(
                map(data, ({ fields: { leadership }, sys: { id } }) => {
                  const contactID = get(
                    find(leadership, 'fields.email'),
                    'sys.id',
                  )
                  return `contact.id_${contactID}.church${id}`
                }),
              )
            }
          >
            {churches =>
              compact(
                churches.map(({ fields: { title, leadership }, sys: { id } }) => {
                  const contactID = get(
                    find(leadership, 'fields.email'),
                    'sys.id',
                  )
                  return contactID ? (
                    <option
                      key={contactID}
                      value={`contact.id_${contactID}.church${id}`}
                    >
                      {title}
                    </option>
                  ) : null
                }),
              )
            }
          </ContentfulQuery>
        </optgroup>

        <optgroup label="Committees">
          <ContentfulQuery
            query={{
              content_type: 'contactGroup',
              'fields.type': 'committee',
              select: 'fields.name,fields.chairperson',
            }}
            afterFetch={data =>
              this.context.refreshDefaultContactID(
                map(data, ({ fields: { chairperson }, sys: { id } }) => {
                  const contactID = get(chairperson, 'fields.email')
                    ? get(chairperson, 'sys.id')
                    : null
                  return `contact.id_${contactID}.committee${id}`
                }),
              )
            }
          >
            {committees =>
              compact(
                committees.map(
                  ({ fields: { name, chairperson }, sys: { id } }) => {
                    const contactID = get(chairperson, 'fields.email')
                      ? get(chairperson, 'sys.id')
                      : null
                    if (contactIDParam === `committee${id}`) {
                      console.log(id)
                    }
                    return contactID ? (
                      <option
                        key={contactID}
                        value={`contact.id_${contactID}.committee${id}`}
                      >
                        {name}
                      </option>
                    ) : null
                  },
                ),
              )
            }
          </ContentfulQuery>
        </optgroup>
      </Field>
    )
  }
}

export default PersonToContactInput
